import { AppPermissionChecker, useApps } from '@auth/useApps'
import { useDialog } from '@globals/dialog/useDialogStore'
import { LICENSING_DIALOG_KEY } from './LicensingDialog'

const useUpgradeLicense = () => {
  const { openDialog } = useDialog(LICENSING_DIALOG_KEY)

  const [hasAppPermission] = useApps()

  return {
    showUpgradeDialog: () => openDialog(),
    interceptClick: (
      event: React.MouseEvent<HTMLAnchorElement>,
      shouldShowDialog: (permissionChecker: AppPermissionChecker) => boolean,
      originalOnClick?: (event?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void,
    ) => {
      if (shouldShowDialog(hasAppPermission)) {
        event.preventDefault()
        openDialog()
      } else {
        originalOnClick?.(event)
      }
    },
  }
}

export default useUpgradeLicense
